import {
  CreateFeedWritePayload,
  FeedEntriesPage,
  FeedWriteQueuedResponse,
  ListFeedEntriesQuery,
  ListFeedEntriesResponse,
} from '~/types/contracting/feed';

import { json_headers, request } from './common';

function feedEntriesPath(): string {
  return `${window.configs.API_HOST}/api/contracting/v1/feed-entries`;
}

export async function listFeedEntries(
  query: ListFeedEntriesQuery,
  pageToken: string | undefined,
  options?: { signal?: AbortSignal },
): Promise<FeedEntriesPage> {
  const search = new URLSearchParams({
    parent_type: query.parent_type,
    parent_salesforce_id: query.parent_salesforce_id,
    sort: query.sort,
  });
  if (query.filter) {
    search.set('filter', query.filter);
  }
  if (pageToken) {
    search.set('page_token', pageToken);
  }

  const response: ListFeedEntriesResponse = await request(`${feedEntriesPath()}?${search.toString()}`, {
    method: 'GET',
    signal: options?.signal,
  });

  return { entries: response.result, nextPageToken: response.pagination.next_page_token };
}

export async function createFeedEntry(payload: CreateFeedWritePayload): Promise<string> {
  const response: FeedWriteQueuedResponse = await request(feedEntriesPath(), {
    method: 'POST',
    headers: json_headers,
    body: JSON.stringify(payload),
  });

  return response.result.write_id;
}

export async function createFeedComment(feedEntryId: string, payload: CreateFeedWritePayload): Promise<string> {
  const path = `${feedEntriesPath()}/by-external-ref/salesforce/${encodeURIComponent(feedEntryId)}/comments`;
  const response: FeedWriteQueuedResponse = await request(path, {
    method: 'POST',
    headers: json_headers,
    body: JSON.stringify(payload),
  });

  return response.result.write_id;
}
